<template>
  <div class="notifi-card-root">
    <NotifiSubscriptionCard
      v-if="subscriptionCardState.state === 'fetched'"
      :sign-message-params="props.signMessageParams"
      :card-data="subscriptionCardState.data"
      :inputs="props.inputs ?? {}"
      @on-alert-detail-selected="handleSelectDetail"
    />
    <div v-if="subscriptionCardState.state === 'loading'"><LoadingView /></div>
    <div v-if="subscriptionCardState.state === 'error'">
      <ErrorView :reason="subscriptionCardState.reason" />
    </div>
    <div v-if="errorMessage !== ''" class="alert-error-content">
      <label> {{ errorMessage }}</label>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch, onMounted } from 'vue';
import { useNotifiStore } from '../stores';

import {
  newAptosConfig,
  newAptosClient,
  NotifiFrontendClient,
  NotifiEnvironment,
} from '@notifi-network/notifi-frontend-client';

import { NotifiSubscriptionCard } from './views/subscription';
import { storeToRefs } from 'pinia';
import { LoadingView, ErrorView } from './views/';
import { Types } from '@notifi-network/notifi-graphql';

const notifiStore = useNotifiStore();
const { subscriptionCardState, errorMessage } = storeToRefs(notifiStore);
const { setNotifiClient, setSubscriptionCardState, setmyWalletAddress } =
  notifiStore;

const props = defineProps<{
  walletAddress: string;
  publicKey: string;
  environment: NotifiEnvironment;
  tenantId: string;
  signMessageParams: Parameters<NotifiFrontendClient['logIn']>[0];
  cardId: string;
  inputs?: Record<string, string | undefined>;
}>();

const notifiClient = computed(() => {
  const { walletAddress, publicKey, environment, tenantId } = props;
  const config = newAptosConfig(
    {
      address: walletAddress,
      publicKey,
    },
    tenantId,
    environment,
  );

  const client = newAptosClient(config);
  return client;
});

function fetchCardState() {
  notifiClient.value
    .fetchSubscriptionCard({
      cardId: props.cardId,
    })
    .then((result) => {
      setSubscriptionCardState({ state: 'fetched', data: result });
    })
    .catch((e) => {
      setSubscriptionCardState({
        state: 'error',
        reason: e,
      });
    });
}

async function handleNotifiClient(
  newClient: NotifiFrontendClient,
): Promise<void> {
  setNotifiClient(newClient);
}

watch(() => notifiClient.value, handleNotifiClient);
watch(() => props.walletAddress, setmyWalletAddress);

onMounted(async () => {
  fetchCardState();
  handleNotifiClient(notifiClient.value);
});

watch(
  () => props.cardId,
  () => {
    fetchCardState();
  },
);

const emit = defineEmits(['onAlertDetailSelected']);

const handleSelectDetail = (
  sourceItem?: Types.NotificationHistoryEntryFragmentFragment,
) => {
  emit('onAlertDetailSelected', sourceItem);
};
</script>

<style lang="scss" scoped>
.notifi-card-root {
  height: 425px;
  display: flex;
  flex-direction: column;
}
</style>
